import React from "react";
import { IdentifierField } from "../../../../common/components/IdentifierField";

/**
 * Componente custom para el campo Publisher.caeIpi. Al salir del campo guarda el
 * CAE/IPI con sus 11 dígitos (un CAE de 9 queda con 00 adelante) y muestra el error de
 * la regla; el detalle está en IdentifierField, común a los cuatro campos de
 * identificadores. Es obligatorio: el form ya exige que no esté vacío, por eso no va
 * `optional`.
 *
 * Llená/editá este archivo en `develop`. El generador lo emite como stub estable en
 * `base` (merge-safe). Recibe los mismos props que un control estándar del form.
 */
export interface PublisherCaeIpiCustomFieldProps {
  value: any;
  onChange: (value: any) => void;
  error?: boolean;
  helperText?: string;
  label?: string;
  description?: string;
}

export const PublisherCaeIpiCustomField: React.FC<PublisherCaeIpiCustomFieldProps> = (
  props
) => <IdentifierField kind="ipi" {...props} />;
